export const trackReadReceipts = "sF7oy";
export default {trackReadReceipts};